import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 25px;
  a {
    text-decoration: none !important;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const ContainerClass = styled.div`
  max-width: 100vw;
  // margin: auto;
  // padding: auto;
  width: 100%;
  padding:0 2vw;
  box-sizing: border-box;
  height: 4rem;
  background: #EAF0D5;
  position: fixed;
  border-bottom: 1px solid #3435354D;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 0.75rem;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width:100%;
  // padding-bottom: 16px;
  // border-bottom: 1px solid #6ee2f54d;
  justify-content: space-between;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0 0.75rem;
  }
`;

export const Row = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  font-size: 30px;
  font-weight: 700;
  color: var(--primary-color);
`;

export const UserContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  button:hover {
    background-color: transparent !important;
  }
  .nv-bellIcon {
    color: var(--icon-colors) !important;
    width: 100px !important;
    height: auto !important;
  }
  .heart-icon{
  color :  var(--icon-colors) !important;
  }
`;

export const Dropdown = styled.div`
  position: relative;
  cursor: pointer;
  color: var(--icon-colors);
`;

export const DropdownTop = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 8px;
  border-radius: 12px;
  display: flex;
  gap: 10px;
  align-items: center;
  // background: var(--primary-button-color);
  h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color:var(--secondary-color,#fff)
  }
`;

export const Avatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 4.8px;
`;

export const DropdownBottom = styled.div`
  position: absolute;
  right: 0;
  z-index: 1000;
  width: 166px;
  background: var(--primary-button-color);

  border-radius: 12px;
  padding: 8px;
  margin-top: 4px;
  a {
    text-decoration: none;
  }
`;

export const DropdownOption = styled.div`
  display: flex;
  align-items: end;
  padding: 6px;
  span {
    font-size: 14px;
    margin-left: 6px;
    color: var(--secondary-color);
  }
  .signout {
    color: #f47c9a;
  }
`;

export const BackButton = styled.div`
  width: fit-content;
  height: 30px;
  cursor: pointer;

  div {
    border: 1px solid var(--primary-color);
    border-radius: 8px;
    padding: 4px 15px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    outline: none;
    font-size: 14px;
    font-weight: 400;
    -webkit-background-clip: text;
    background: var(--primary-color);
    background-clip: text;
    color: transparent;
  }
`;
export const PopUpContainer = styled.div`
  width: 460px;
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  .popup-title {
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    padding: 10px 40px;
    color: var(--primary-label-color);
  }
`;
